import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { ConfigProvider, App, theme } from "antd";
import locale from "antd/locale/zh_CN";
import { getAppInfo } from "@/services";
import { generateThemeConfig } from "@/utils";
import { ThemeProvider, useThemeContext } from "@/contexts";
import AppRouter from "@/app-router";
import AppClosedPage from "@/pages/app-closed";
import "@/global.css";

dayjs.locale("zh-cn");

// 包装组件，用于获取主题状态并传递给 ConfigProvider
const AppPlatform: React.FC = () => {
  const [appInfo, setAppInfo] = useState(null);
  const [themeConfig, setThemeConfig] = useState(null);
  const { themeMode } = useThemeContext();

  // 异步获取appInfo
  useEffect(() => {
    getAppInfo().then((res) => {
      setAppInfo(res);
      setThemeConfig(generateThemeConfig(res)); // TODO: 暗色处理也统一在这个util中进行
    });
  }, []);

  if (!appInfo) return;

  return (
    <ConfigProvider
      locale={locale}
      theme={
        themeMode === "dark"
          ? {
              token: {
                ...themeConfig.token,
                colorTextBase: "rgba(255, 255, 255, 0.85)", // 暗色模式下, 文本色需要设置为白色
              },
              components: themeConfig.components || {},
              algorithm: theme.darkAlgorithm,
              cssVar: true, // 重要, 必须开启 antd css 变量
            }
          : {
              ...themeConfig,
              algorithm: theme.defaultAlgorithm,
              cssVar: true, // 重要, 必须开启 antd css 变量
            }
      }
    >
      <App>
        {/* 根据应用发布状态确定如何渲染 */}
        {appInfo.appPublishStatus === "PUBLISHED" ? (
          <AppRouter />
        ) : (
          <AppClosedPage />
        )}
      </App>
    </ConfigProvider>
  );
};

const container = document.getElementById("root");

createRoot(container!).render(
  <ThemeProvider>
    <AppPlatform />
  </ThemeProvider>,
);
